import React from "react";
import signOut from "../functions/cerrarSesion";
import { Container, Stack, Button, Form, Table } from "react-bootstrap";
import getAllProducts from "../functions/getAllProducts";
import eliminarProductoHome from "../functions/eliminarProductoHome";
import Navbartrabajo from '../../Navbars/Navbartrabajo';
import getProductos_orden from "../functions/getProductos_orden";
import Home_ordenes from './Home_ordenes';
import { DataContextProvider } from "../../Contexts/DataContext";
import getProductos_ordenPDF from "../functions/getProductos_ordenPDF";
import Swal from "sweetalert2";
import editar_asegurado_fecha from "../functions/Seguro_social/editar_asegurado_fecha";
//modales
import ModalAñadir_ordenes_principal from "../components/ModalAñadir_ordenes_principal";
import ModalEditar_ordenes_principal from "../components/ModalEditar_ordenes_principal";
//Generar PDF
import ErrorBoundary from '../components/Salvavidas';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

function Home_ordenes_principal({ usuario }) {
  
  //Convertir a formato moneda
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
})

  //Eliminar con sweetalert2
function eliminar_sweetalert(producto, usuario) {
    Swal.fire({
      title: '¿Esta seguro de eliminar la orden de compra con folio #'+ producto.nombre+'?',
      text: "Esta acción no se puede restablecer!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, eliminar.'
    }).then((result) => {
      if (result.isConfirmed) {
        //Traer productos de lla orden
        const valor = producto.nombre;
        getProductos_ordenPDF(valor).then((productos2) => {
          if(productos2.length==0){
            eliminarProductoHome(producto, usuario.email).then(
              (confirmacion) => {
                //actualizarEstadoProductos();
                var auxiliar = [];
                setProductos(auxiliar);
                Swal.fire(
                  'Eliminado!',
                  'La orden ha sido eliminada.',
                  'success'
                )
              }
            );
          }else{
            Swal.fire({
              icon: 'error',
              text: "Para poder eliminar la orden de compra es necesario eliminar todos los productos que contiene, una vez se encuentre sin productos se podra eliminar.",
              footer: '¿Que hacer? <br/> Se debe ingresar a los productos de la orden seleccionada y eliminarlos.'
            }) 
           }
       }); 
      }
    })
  }
  
  const [Productos_Orden, setProductos_Orden] = React.useState([]);

  async function pdfGenerate(producto){
    //Traer productos de lla orden
    const valor = producto.nombre;
    await getProductos_ordenPDF(valor).then((productos2) => {
      setProductos_Orden(productos2); 
      pdfGenerate2(productos2, valor, producto)
      console.log(productos2)
    });
    
  }

//PDF
function pdfGenerate2(productos2, valor, producto){
  const datos_subtotal= productos2.map(cantidad_subtotal=> cantidad_subtotal.subtotal);
  var subtotal=0;
  for(let i of datos_subtotal) subtotal+=i;
  console.log(productos2)
  var iva=0;

  productos2.map((dato)=>{
    var auxiliar100 = formatter.format(+iva + +dato.iva)
    var n_str = auxiliar100.toString();

    const n_nuevaStr = n_str.replace("$", "");
    const n_nuevaStr2 = n_nuevaStr.replace(",", "");
    const n_nuevaStr3 = n_nuevaStr2.replace(",", "");
    var n_nuevaStr4 = n_nuevaStr3.replace(",", "");
    iva = n_nuevaStr4;
  })

  //Total
  var total = formatter.format(+iva + +subtotal)
  console.log(subtotal, iva, total)
  //var total = producto.total_orden;

   //landscape es horizontal la pagina y portrait vertical
   var doc=new jsPDF('portrait', 'px', 'a4', 'false');
  var imgData="data:image/jpeg;base64,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"
   doc.addImage(imgData,30,1,90,70);
   //Agrega pagina tipo a4 y vertical por le portrait
   //doc.addPage("a4", "portrait")
   //Agrega texto el primer dato es posicion horizontal el segundo vertical}
   doc.setFontSize(13);
   doc.text("ORDEN DE COMPRA", 204,50)
   doc.text("____________________", 198,51)
/*    doc.setFontSize(11);
   doc.text("PRODUCTO DE MÉXICO", 205,62) */
   doc.setFontSize(10);
   doc.text("SOLICITO: ", 10,100);       doc.text(""+producto.solicitante, 75,100)
   doc.text("PROVEEDOR: ", 10,110);      doc.text(""+producto.proveedor, 75,110)
   doc.text("MONEDA: ", 10,120);         doc.text(""+producto.moneda, 75,120)
   doc.setFontSize(18);
   doc.text("HORTICOLA LUIPACK, SPR DE RL", 150 ,15)
   doc.setFontSize(6);
   doc.text("BLVD EMILIANO ZAPATA NO. 804 PTE", 165 ,23)
   doc.text("PUEBLO YAQUI, SONORA MEXICO CP 85200", 248,23)
   doc.text("EMAIL: MANIFIESTOSHORTICOLA@GMAIL.COM", 205 ,28)
   doc.text("RFC: HLS-970821-NB0", 175 ,33)
   doc.text("TEL: + 52 (643) 4371010", 231,33)
   doc.text("FDA: 19991703164", 290,33)
   doc.setFontSize(10);
   doc.text("FECHA: ", 342,100);          doc.text(""+producto.fecha, 380,100)
   doc.text("FOLIO: ", 342,110);          doc.text(""+valor, 380,110)
   
   //TABLA con productos
   if(producto.comentarios_orden==undefined){

   }else{
    doc.text("Comentarios: ", 10, 130); doc.text(""+producto.comentarios_orden, 75,130)
   }

productos2.map((dato10)=>{
  
  var auxiliar1000 = formatter.format(dato10.precio);
  const str = (auxiliar1000).toString();
  const nuevaStr = str.replace("$", "");
  dato10['precio'] = nuevaStr;

  var auxiliar1001 = formatter.format(dato10.subtotal);
  const str_2 = (auxiliar1001).toString();
  const nuevaStr_2 = str_2.replace("$", "");
  dato10['subtotal'] = nuevaStr_2;
})

  var columns = [
    { title: "Producto", dataKey: "producto" },
    { title: "Cantidad", dataKey: "cantidad" },
    { title: "Unidad", dataKey: "unidad" },
    { title: "Precio", dataKey: "precio" },
    { title: "Subtotal", dataKey: "subtotal"},
  ];

  var rows = 
    productos2
  ;

   doc.autoTable(columns, rows, {
    startY: doc.autoTableEndPosY() + 140,
    margin: { horizontal: 10 },
    styles: { overflow: 'linebreak' , halign: 'center'},
    bodyStyles: { valign: 'top'},
    columnStyles: {0: { cellWidth: 'wrap', halign: 'left' } , 1: { cellWidth: 'wrap', halign: 'right' } , 2: { cellWidth: 'wrap', halign: 'center' } , 3: { cellWidth: 'wrap', halign: 'right' } , 4: { cellWidth: 'wrap', halign: 'right' } },
    theme: "grid"
  });
 
   doc.setFontSize(10);

   //NOTA formatter.format sirve para pasar un valor numerico a moneda, le agrega el signo $ y las , de los miles
   doc.text("SUBTOTAL: ", 300,528);
   doc.text((formatter.format(subtotal.toString())), 350,528)
   //doc.text(parseFloat((subtotal.toString())).toFixed(2), 350,528);

   doc.text("IVA: ", 300,550);
   doc.text((formatter.format(iva.toString())), 350,550)
   //doc.text(parseFloat((iva.toString())).toFixed(2), 350,550);

   doc.text("TOTAL: ", 300,572);
   doc.text(total , 350,572)
   //doc.text((formatter.format(total.toString())), 350,572)
   //doc.text(parseFloat((total.toString())).toFixed(2), 350,572)


   //Fuente de la letra afecta de donde se pone para abajo lo de arriba no
   //doc.setFont('courier')
   //doc.text(60,200, e.proveedor)
   //Es para descargar el PDF
   //doc.save('Orden '+productos.fecha+'.pdf')
   doc.save('Orden '+valor+'.pdf')
}
  
  const [productos, setProductos] = React.useState([]);
  const [isModalAñadir, setIsModalAñadir] = React.useState(false);

  const [isModalEditar, setIsModalEditar] = React.useState(false);
  const [productoEditar, setProductoEditar] = React.useState(null);

  async function busquedaFormHandler(productos) {
    //productos.preventDefault();
    console.log(productos);
    //Filtro 1
    const busqueda = document.getElementById("busqueda").value;
    console.log(busqueda)
    var productos_filtrados1 = [];
    productos.map((datos)=>{
      if((datos.nombre==busqueda) || (datos.proveedor==busqueda) ||
       (datos.cargo==busqueda) || (datos.tipo_compra==busqueda) ||
       (datos.moneda==busqueda) || (datos.fecha==busqueda) ||
       (datos.solicitante==busqueda)){
        console.log("Hola")
        productos_filtrados1.push(datos);
      }
    })

    //Filtro 2
    const busqueda2 = document.getElementById("busqueda2").value;
    console.log(busqueda2)
    if(busqueda2 ==""){
      setProductos(productos_filtrados1);
    }else{
      var productos_filtrados2 = [];
      productos_filtrados1.map((datos)=>{
        if((datos.nombre==busqueda2) || (datos.proveedor==busqueda2) ||
         (datos.cargo==busqueda2) || (datos.tipo_compra==busqueda2) ||
         (datos.moneda==busqueda2) || (datos.fecha==busqueda2) ||
         (datos.solicitante==busqueda2)){
          console.log("Hola2")
          productos_filtrados2.push(datos);
        }
      })
      setProductos(productos_filtrados2);
    }
   
    
    
    
    
  }


  const [Ordenes_todas, setOrdenes_todas] = React.useState(false);

  //Traer todas las ordenes de compra
  function actualizarEstadoProductos() {
    getAllProducts().then((productos) => {
    //Todo esto sirve para ordenar de mayor a menor las ordenes por el folio  
    var folios_ordenar = [];
      productos.map((datos)=>{
        folios_ordenar.push(datos.nombre)
      })
      
      //Esto sirve para organizar de mayor a menor si quiero de menor a mayo tengo que cambiar el b-a => a-b
      var folios_ordenados = folios_ordenar.sort(function(a, b){return b - a})

      var ordenes_organizadas = [];

      folios_ordenados.map((valores)=> {
        productos.map((datos2)=>{
          if(valores==datos2.nombre){
            ordenes_organizadas.push(datos2);
          }
        })
      })

     console.log(ordenes_organizadas);
     setOrdenes_todas(true);
     setProductos(ordenes_organizadas);
     //Con este se agrego la fecha en formateo Date para poder ordenar todas las ordenes
     //editar_asegurado_fecha(ordenes_organizadas)
    });
  }

/* 
  //Traer todas las ordenes de compra
  function actualizarEstadoProductos() {
    getAllProducts().then((productos) => {
      actualizarEstadoProductos2(productos); 
      console.log(productos)
    });
  }

 //Este sirve para esperar el tiempo que quieras ya que no se actualizaba correcamente
 function timeout(delay){
  return new Promise(res => setTimeout(res, delay));
}

  async function actualizarEstadoProductos2(productos) {

    productos.map((ordenes)=>{
      var datostotal = 0;
      var producto_categoria= false;
      var iva = 0;
      var subtotal=0;
      var total = 0;
      const productofolio = ordenes.nombre;
      getProductos_orden(productofolio).then((productos2) => {
              console.log(productos2)
              //Este sirve para sacar el total de todos los productos de la orden 
              datostotal= productos2.map(cantidad=> (cantidad.cantidad)*(cantidad.precio));
              console.log(datostotal)
              //Este map sirve para ver si es un fertilizante o semilla y quitarle el iva
                productos2.map((ordenes_productos)=>{
                      if(ordenes_productos.categoria== "Fertilizantes y agroquimicos"){
                        producto_categoria = true;
                      }
                      if(ordenes_productos.categoria== "Semillas"){
                        producto_categoria = true;
                      }
                }); //Segundo map
          
          //Esto es para sumarle el iva si es que aplica
          for(let i of datostotal) subtotal+=i;
          if(producto_categoria){
          }else{iva = subtotal*0.16;}  
          total = iva + subtotal;
          console.log(total);
          //Con esto le agrego el total a las ordenes
          ordenes['total'] = total.toString();
      }); //Fin de getProductos_orden
      
    });
    //Sin este timeout no se carga correctamente el total y lo deja en undefined
    await timeout(500);
    setProductos(productos);
    console.log(productos)
  } */

  function añadirProductoHome() {
    setIsModalAñadir(true);
  }

  const [cambio, setcambio] = React.useState(null);
  const [Enviarproducto, setEnviarproducto] = React.useState({});

  function cambio_pagina(producto){
    //console.log(producto)
    setEnviarproducto({ ...producto });
    setcambio(true);
  }

  //Este sirve para regresar a seleccionar cuando se presione regresar
  function Pagina_principal(){
    setcambio(false)
}

  React.useEffect(() => {
    //actualizarEstadoProductos();
  }, []);

  return (
  <div>

        {cambio? 
       <DataContextProvider>
          <Home_ordenes 
            Enviarproducto = {Enviarproducto}
            productofolio ={Enviarproducto.nombre}
            productocargo ={Enviarproducto.cargo}
            setcambio={setcambio}
            usuario={usuario}
            Pagina_principal={()=>Pagina_principal()}
            setProductosprincipal={setProductos}
          />
        </DataContextProvider> 
      :
      <div>
        <Navbartrabajo/>
    
    <Container fluid id="Navbar_trabajo_home">
     {isModalAñadir && (
      <ModalAñadir_ordenes_principal
        isModalAñadir={isModalAñadir}
        setIsModalAñadir={setIsModalAñadir}
        actualizarEstadoProductos={actualizarEstadoProductos}
        productoEditar={productoEditar}
        setProductoEditar={setProductoEditar}
        usuario={usuario}
        setProductos={setProductos}
      />
     )}  
      {productoEditar && (
        <ModalEditar_ordenes_principal
          isModalEditar={isModalEditar}
          setIsModalEditar={setIsModalEditar}
          actualizarEstadoProductos={actualizarEstadoProductos}
          productoEditar={productoEditar}
          setProductoEditar={setProductoEditar}
          usuario={usuario}
        />
      )}
      <br/>
      <Stack direction="horizontal" className="justify-content-between">
        <p style={{ fontSize: 20  }}>Bienvenido {usuario.email}, Actualmente estas en {window.location.pathname} </p>
        <Button onClick={añadirProductoHome}> Añadir orden de compra</Button>
        <Button onClick={actualizarEstadoProductos}> Ver todas las ordenes</Button>
        <Button onClick={signOut}>Cerrar sesión</Button>
      </Stack>
      

    {Ordenes_todas && (
      <div>
      <hr />
      <Form>
        <h6>Al realizar un filtro y querer volver a realizar un segundo, se tiene que presionar el botón de resetear</h6>
        <Stack direction="horizontal">
          <Form.Group className="w-75 m-3">
            <Form.Control id="busqueda"  style={{ fontSize: 14, height: "80%" }} type="text" placeholder="Filtro 1, se pude buscar por todo menos por el total ejemplo, folio, proveedor, solicitante, etc." />
         </Form.Group>
          <Form.Group  className="w-75 m-3">
            <Form.Control id="busqueda2" style={{ fontSize: 14, height: "80%" }} type="text" placeholder="Filtro 2, este filtro filtra a los que ya se filtraron en el filtro 1 " />
          </Form.Group>
          <Button variant="dark"
          onClick={() => {
            busquedaFormHandler(productos);
          }}
          >
            Buscar
          </Button>
          <Button
            variant="light"
            onClick={() => {
              actualizarEstadoProductos();
            }}
          >
            Resetear
          </Button>
        </Stack>
      </Form>
     </div>
    )}
      

      <hr />
      <Table>
        <thead>
          <tr>
            {/* <th>#</th> */}
            <th>Folio</th>
            <th>Fecha</th>
            <th>Proveedor</th>
            <th>Moneda</th>
            <th>Cargo</th>
            <th>Solicito</th>
            <th>Tipo de compra</th>
            <th>Factura</th>
            <th>Total de orden</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {productos &&
            productos.map((producto, index) => (
              <tr key={index}>
                <td>#{producto.nombre}</td>
                <td>{producto.fecha}</td>        
                <td>{producto.proveedor}</td>
                <td>{producto.moneda}</td>
                <td>{producto.cargo}</td>
                <td>{producto.solicitante}</td>
                <td>{producto.tipo_compra}</td>
                <td>#{producto.factura}</td>
                <td>{producto.total_orden}</td>
                <td>
                  <Button
                    variant="dark"
                    onClick={() => {
                      setProductoEditar({ ...producto });
                      setIsModalEditar(true);
                    }}
                  >
                    Editar
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => {
                      eliminar_sweetalert(producto, usuario);
                    }}
                  >
                    Eliminar
                  </Button>
                  <Button
                  variant="warning"
                  onClick={()=>{pdfGenerate({ ...producto })}}
                  >
                   Generar PDF
                  </Button>
                  
                  <Button
                  variant="success"
                  onClick={()=>{cambio_pagina({ ...producto })}}
                  >
                   Productos
                  </Button>

                  {/* <Link variant="warning" to='/Ordenes_compra'>Productos</Link> */}

                </td>
              </tr>
            ))}
        </tbody>
      </Table>
{/*       <Button onClick={añadirProductoHome}> Añadir orden de compra</Button> */}
      <br/>
      <br/>
 
    </Container>
    
      </div>
      }


    
    </div>
  );
}

export default Home_ordenes_principal;

/* */